////https://github.com/lukes/ISO-3166-Countries-with-Regional-Language_codes

export const COUNTRIES = [
  {
    name: 'Afghanistan',
    alpha_2: 'AF',
    alpha_3: 'AFG',
    location_code: '2004',
  },
  {
    name: 'Åland Islands',
    alpha_2: 'AX',
    alpha_3: 'ALA',
    location_code: '2248',
  },
  {
    name: 'Albania',
    alpha_2: 'AL',
    alpha_3: 'ALB',
    location_code: '2008',
  },
  {
    name: 'Algeria',
    alpha_2: 'DZ',
    alpha_3: 'DZA',
    location_code: '2012',
  },
  {
    name: 'American Samoa',
    alpha_2: 'AS',
    alpha_3: 'ASM',
    location_code: '2016',
  },
  {
    name: 'Andorra',
    alpha_2: 'AD',
    alpha_3: 'AND',
    location_code: '2020',
  },
  {
    name: 'Angola',
    alpha_2: 'AO',
    alpha_3: 'AGO',
    location_code: '2024',
  },
  {
    name: 'Anguilla',
    alpha_2: 'AI',
    alpha_3: 'AIA',
    location_code: '2660',
  },
  {
    name: 'Antarctica',
    alpha_2: 'AQ',
    alpha_3: 'ATA',
    location_code: '2010',
  },
  {
    name: 'Antigua and Barbuda',
    alpha_2: 'AG',
    alpha_3: 'ATG',
    location_code: '2028',
  },
  {
    name: 'Argentina',
    alpha_2: 'AR',
    alpha_3: 'ARG',
    location_code: '2032',
  },
  {
    name: 'Armenia',
    alpha_2: 'AM',
    alpha_3: 'ARM',
    location_code: '2051',
  },
  {
    name: 'Aruba',
    alpha_2: 'AW',
    alpha_3: 'ABW',
    location_code: '2533',
  },
  {
    name: 'Australia',
    alpha_2: 'AU',
    alpha_3: 'AUS',
    location_code: '2036',
  },
  {
    name: 'Austria',
    alpha_2: 'AT',
    alpha_3: 'AUT',
    location_code: '2040',
  },
  {
    name: 'Azerbaijan',
    alpha_2: 'AZ',
    alpha_3: 'AZE',
    location_code: '2031',
  },
  {
    name: 'Bahamas',
    alpha_2: 'BS',
    alpha_3: 'BHS',
    location_code: '2044',
  },
  {
    name: 'Bahrain',
    alpha_2: 'BH',
    alpha_3: 'BHR',
    location_code: '2048',
  },
  {
    name: 'Bangladesh',
    alpha_2: 'BD',
    alpha_3: 'BGD',
    location_code: '2050',
  },
  {
    name: 'Barbados',
    alpha_2: 'BB',
    alpha_3: 'BRB',
    location_code: '2052',
  },
  {
    name: 'Belarus',
    alpha_2: 'BY',
    alpha_3: 'BLR',
    location_code: '2112',
  },
  {
    name: 'Belgium',
    alpha_2: 'BE',
    alpha_3: 'BEL',
    location_code: '2056',
  },
  {
    name: 'Belize',
    alpha_2: 'BZ',
    alpha_3: 'BLZ',
    location_code: '2084',
  },
  {
    name: 'Benin',
    alpha_2: 'BJ',
    alpha_3: 'BEN',
    location_code: '2204',
  },
  {
    name: 'Bermuda',
    alpha_2: 'BM',
    alpha_3: 'BMU',
    location_code: '2060',
  },
  {
    name: 'Bhutan',
    alpha_2: 'BT',
    alpha_3: 'BTN',
    location_code: '2064',
  },
  {
    name: 'Bolivia (Plurinational State of)',
    alpha_2: 'BO',
    alpha_3: 'BOL',
    location_code: '2068',
  },
  {
    name: 'Bonaire, Sint Eustatius and Saba',
    alpha_2: 'BQ',
    alpha_3: 'BES',
    location_code: '2535',
  },
  {
    name: 'Bosnia and Herzegovina',
    alpha_2: 'BA',
    alpha_3: 'BIH',
    location_code: '2070',
  },
  {
    name: 'Botswana',
    alpha_2: 'BW',
    alpha_3: 'BWA',
    location_code: '2072',
  },
  {
    name: 'Bouvet Island',
    alpha_2: 'BV',
    alpha_3: 'BVT',
    location_code: '2074',
  },
  {
    name: 'Brazil',
    alpha_2: 'BR',
    alpha_3: 'BRA',
    location_code: '2076',
  },
  {
    name: 'British Indian Ocean Territory',
    alpha_2: 'IO',
    alpha_3: 'IOT',
    location_code: '2086',
  },
  {
    name: 'Brunei Darussalam',
    alpha_2: 'BN',
    alpha_3: 'BRN',
    location_code: '2096',
  },
  {
    name: 'Bulgaria',
    alpha_2: 'BG',
    alpha_3: 'BGR',
    location_code: '2100',
  },
  {
    name: 'Burkina Faso',
    alpha_2: 'BF',
    alpha_3: 'BFA',
    location_code: '2854',
  },
  {
    name: 'Burundi',
    alpha_2: 'BI',
    alpha_3: 'BDI',
    location_code: '2108',
  },
  {
    name: 'Cabo Verde',
    alpha_2: 'CV',
    alpha_3: 'CPV',
    location_code: '2132',
  },
  {
    name: 'Cambodia',
    alpha_2: 'KH',
    alpha_3: 'KHM',
    location_code: '2116',
  },
  {
    name: 'Cameroon',
    alpha_2: 'CM',
    alpha_3: 'CMR',
    location_code: '2120',
  },
  {
    name: 'Canada',
    alpha_2: 'CA',
    alpha_3: 'CAN',
    location_code: '2124',
  },
  {
    name: 'Cayman Islands',
    alpha_2: 'KY',
    alpha_3: 'CYM',
    location_code: '2136',
  },
  {
    name: 'Central African Republic',
    alpha_2: 'CF',
    alpha_3: 'CAF',
    location_code: '2140',
  },
  {
    name: 'Chad',
    alpha_2: 'TD',
    alpha_3: 'TCD',
    location_code: '2148',
  },
  {
    name: 'Chile',
    alpha_2: 'CL',
    alpha_3: 'CHL',
    location_code: '2152',
  },
  {
    name: 'China',
    alpha_2: 'CN',
    alpha_3: 'CHN',
    location_code: '2156',
  },
  {
    name: 'Christmas Island',
    alpha_2: 'CX',
    alpha_3: 'CXR',
    location_code: '2162',
  },
  {
    name: 'Cocos (Keeling) Islands',
    alpha_2: 'CC',
    alpha_3: 'CCK',
    location_code: '2166',
  },
  {
    name: 'Colombia',
    alpha_2: 'CO',
    alpha_3: 'COL',
    location_code: '2170',
  },
  {
    name: 'Comoros',
    alpha_2: 'KM',
    alpha_3: 'COM',
    location_code: '2174',
  },
  {
    name: 'Congo',
    alpha_2: 'CG',
    alpha_3: 'COG',
    location_code: '2178',
  },
  {
    name: 'Congo, Democratic Republic of the',
    alpha_2: 'CD',
    alpha_3: 'COD',
    location_code: '2180',
  },
  {
    name: 'Cook Islands',
    alpha_2: 'CK',
    alpha_3: 'COK',
    location_code: '2184',
  },
  {
    name: 'Costa Rica',
    alpha_2: 'CR',
    alpha_3: 'CRI',
    location_code: '2188',
  },
  {
    name: "Côte d'Ivoire",
    alpha_2: 'CI',
    alpha_3: 'CIV',
    location_code: '2384',
  },
  {
    name: 'Croatia',
    alpha_2: 'HR',
    alpha_3: 'HRV',
    location_code: '2191',
  },
  {
    name: 'Cuba',
    alpha_2: 'CU',
    alpha_3: 'CUB',
    location_code: '2192',
  },
  {
    name: 'Curaçao',
    alpha_2: 'CW',
    alpha_3: 'CUW',
    location_code: '2531',
  },
  {
    name: 'Cyprus',
    alpha_2: 'CY',
    alpha_3: 'CYP',
    location_code: '2196',
  },
  {
    name: 'Czechia',
    alpha_2: 'CZ',
    alpha_3: 'CZE',
    location_code: '2203',
  },
  {
    name: 'Denmark',
    alpha_2: 'DK',
    alpha_3: 'DNK',
    location_code: '2208',
  },
  {
    name: 'Djibouti',
    alpha_2: 'DJ',
    alpha_3: 'DJI',
    location_code: '2262',
  },
  {
    name: 'Dominica',
    alpha_2: 'DM',
    alpha_3: 'DMA',
    location_code: '2212',
  },
  {
    name: 'Dominican Republic',
    alpha_2: 'DO',
    alpha_3: 'DOM',
    location_code: '2214',
  },
  {
    name: 'Ecuador',
    alpha_2: 'EC',
    alpha_3: 'ECU',
    location_code: '2218',
  },
  {
    name: 'Egypt',
    alpha_2: 'EG',
    alpha_3: 'EGY',
    location_code: '2818',
  },
  {
    name: 'El Salvador',
    alpha_2: 'SV',
    alpha_3: 'SLV',
    location_code: '2222',
  },
  {
    name: 'Equatorial Guinea',
    alpha_2: 'GQ',
    alpha_3: 'GNQ',
    location_code: '2226',
  },
  {
    name: 'Eritrea',
    alpha_2: 'ER',
    alpha_3: 'ERI',
    location_code: '2232',
  },
  {
    name: 'Estonia',
    alpha_2: 'EE',
    alpha_3: 'EST',
    location_code: '2233',
  },
  {
    name: 'Eswatini',
    alpha_2: 'SZ',
    alpha_3: 'SWZ',
    location_code: '2748',
  },
  {
    name: 'Ethiopia',
    alpha_2: 'ET',
    alpha_3: 'ETH',
    location_code: '2231',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    alpha_2: 'FK',
    alpha_3: 'FLK',
    location_code: '2238',
  },
  {
    name: 'Faroe Islands',
    alpha_2: 'FO',
    alpha_3: 'FRO',
    location_code: '2234',
  },
  {
    name: 'Fiji',
    alpha_2: 'FJ',
    alpha_3: 'FJI',
    location_code: '2242',
  },
  {
    name: 'Finland',
    alpha_2: 'FI',
    alpha_3: 'FIN',
    location_code: '2246',
  },
  {
    name: 'France',
    alpha_2: 'FR',
    alpha_3: 'FRA',
    location_code: '2250',
  },
  {
    name: 'French Guiana',
    alpha_2: 'GF',
    alpha_3: 'GUF',
    location_code: '2254',
  },
  {
    name: 'French Polynesia',
    alpha_2: 'PF',
    alpha_3: 'PYF',
    location_code: '2258',
  },
  {
    name: 'French Southern Territories',
    alpha_2: 'TF',
    alpha_3: 'ATF',
    location_code: '2260',
  },
  {
    name: 'Gabon',
    alpha_2: 'GA',
    alpha_3: 'GAB',
    location_code: '2266',
  },
  {
    name: 'Gambia',
    alpha_2: 'GM',
    alpha_3: 'GMB',
    location_code: '2270',
  },
  {
    name: 'Georgia',
    alpha_2: 'GE',
    alpha_3: 'GEO',
    location_code: '2268',
  },
  {
    name: 'Germany',
    alpha_2: 'DE',
    alpha_3: 'DEU',
    location_code: '2276',
  },
  {
    name: 'Ghana',
    alpha_2: 'GH',
    alpha_3: 'GHA',
    location_code: '2288',
  },
  {
    name: 'Gibraltar',
    alpha_2: 'GI',
    alpha_3: 'GIB',
    location_code: '2292',
  },
  {
    name: 'Greece',
    alpha_2: 'GR',
    alpha_3: 'GRC',
    location_code: '2300',
  },
  {
    name: 'Greenland',
    alpha_2: 'GL',
    alpha_3: 'GRL',
    location_code: '2304',
  },
  {
    name: 'Grenada',
    alpha_2: 'GD',
    alpha_3: 'GRD',
    location_code: '2308',
  },
  {
    name: 'Guadeloupe',
    alpha_2: 'GP',
    alpha_3: 'GLP',
    location_code: '2312',
  },
  {
    name: 'Guam',
    alpha_2: 'GU',
    alpha_3: 'GUM',
    location_code: '2316',
  },
  {
    name: 'Guatemala',
    alpha_2: 'GT',
    alpha_3: 'GTM',
    location_code: '2320',
  },
  {
    name: 'Guernsey',
    alpha_2: 'GG',
    alpha_3: 'GGY',
    location_code: '2831',
  },
  {
    name: 'Guinea',
    alpha_2: 'GN',
    alpha_3: 'GIN',
    location_code: '2324',
  },
  {
    name: 'Guinea-Bissau',
    alpha_2: 'GW',
    alpha_3: 'GNB',
    location_code: '2624',
  },
  {
    name: 'Guyana',
    alpha_2: 'GY',
    alpha_3: 'GUY',
    location_code: '2328',
  },
  {
    name: 'Haiti',
    alpha_2: 'HT',
    alpha_3: 'HTI',
    location_code: '2332',
  },
  {
    name: 'Heard Island and McDonald Islands',
    alpha_2: 'HM',
    alpha_3: 'HMD',
    location_code: '2334',
  },
  {
    name: 'Holy See',
    alpha_2: 'VA',
    alpha_3: 'VAT',
    location_code: '2336',
  },
  {
    name: 'Honduras',
    alpha_2: 'HN',
    alpha_3: 'HND',
    location_code: '2340',
  },
  {
    name: 'Hong Kong',
    alpha_2: 'HK',
    alpha_3: 'HKG',
    location_code: '2344',
  },
  {
    name: 'Hungary',
    alpha_2: 'HU',
    alpha_3: 'HUN',
    location_code: '2348',
  },
  {
    name: 'Iceland',
    alpha_2: 'IS',
    alpha_3: 'ISL',
    location_code: '2352',
  },
  {
    name: 'India',
    alpha_2: 'IN',
    alpha_3: 'IND',
    location_code: '2356',
  },
  {
    name: 'Indonesia',
    alpha_2: 'ID',
    alpha_3: 'IDN',
    location_code: '2360',
  },
  {
    name: 'Iran (Islamic Republic of)',
    alpha_2: 'IR',
    alpha_3: 'IRN',
    location_code: '2364',
  },
  {
    name: 'Iraq',
    alpha_2: 'IQ',
    alpha_3: 'IRQ',
    location_code: '2368',
  },
  {
    name: 'Ireland',
    alpha_2: 'IE',
    alpha_3: 'IRL',
    location_code: '2372',
  },
  {
    name: 'Isle of Man',
    alpha_2: 'IM',
    alpha_3: 'IMN',
    location_code: '2833',
  },
  {
    name: 'Israel',
    alpha_2: 'IL',
    alpha_3: 'ISR',
    location_code: '2376',
  },
  {
    name: 'Italy',
    alpha_2: 'IT',
    alpha_3: 'ITA',
    location_code: '2380',
  },
  {
    name: 'Jamaica',
    alpha_2: 'JM',
    alpha_3: 'JAM',
    location_code: '2388',
  },
  {
    name: 'Japan',
    alpha_2: 'JP',
    alpha_3: 'JPN',
    location_code: '2392',
  },
  {
    name: 'Jersey',
    alpha_2: 'JE',
    alpha_3: 'JEY',
    location_code: '2832',
  },
  {
    name: 'Jordan',
    alpha_2: 'JO',
    alpha_3: 'JOR',
    location_code: '2400',
  },
  {
    name: 'Kazakhstan',
    alpha_2: 'KZ',
    alpha_3: 'KAZ',
    location_code: '2398',
  },
  {
    name: 'Kenya',
    alpha_2: 'KE',
    alpha_3: 'KEN',
    location_code: '2404',
  },
  {
    name: 'Kiribati',
    alpha_2: 'KI',
    alpha_3: 'KIR',
    location_code: '2296',
  },
  {
    name: "Korea (Democratic People's Republic of)",
    alpha_2: 'KP',
    alpha_3: 'PRK',
    location_code: '2408',
  },
  {
    name: 'Korea, Republic of',
    alpha_2: 'KR',
    alpha_3: 'KOR',
    location_code: '2410',
  },
  {
    name: 'Kuwait',
    alpha_2: 'KW',
    alpha_3: 'KWT',
    location_code: '2414',
  },
  {
    name: 'Kyrgyzstan',
    alpha_2: 'KG',
    alpha_3: 'KGZ',
    location_code: '2417',
  },
  {
    name: "Lao People's Democratic Republic",
    alpha_2: 'LA',
    alpha_3: 'LAO',
    location_code: '2418',
  },
  {
    name: 'Latvia',
    alpha_2: 'LV',
    alpha_3: 'LVA',
    location_code: '2428',
  },
  {
    name: 'Lebanon',
    alpha_2: 'LB',
    alpha_3: 'LBN',
    location_code: '2422',
  },
  {
    name: 'Lesotho',
    alpha_2: 'LS',
    alpha_3: 'LSO',
    location_code: '2426',
  },
  {
    name: 'Liberia',
    alpha_2: 'LR',
    alpha_3: 'LBR',
    location_code: '2430',
  },
  {
    name: 'Libya',
    alpha_2: 'LY',
    alpha_3: 'LBY',
    location_code: '2434',
  },
  {
    name: 'Liechtenstein',
    alpha_2: 'LI',
    alpha_3: 'LIE',
    location_code: '2438',
  },
  {
    name: 'Lithuania',
    alpha_2: 'LT',
    alpha_3: 'LTU',
    location_code: '2440',
  },
  {
    name: 'Luxembourg',
    alpha_2: 'LU',
    alpha_3: 'LUX',
    location_code: '2442',
  },
  {
    name: 'Macao',
    alpha_2: 'MO',
    alpha_3: 'MAC',
    location_code: '2446',
  },
  {
    name: 'Madagascar',
    alpha_2: 'MG',
    alpha_3: 'MDG',
    location_code: '2450',
  },
  {
    name: 'Malawi',
    alpha_2: 'MW',
    alpha_3: 'MWI',
    location_code: '2454',
  },
  {
    name: 'Malaysia',
    alpha_2: 'MY',
    alpha_3: 'MYS',
    location_code: '2458',
  },
  {
    name: 'Maldives',
    alpha_2: 'MV',
    alpha_3: 'MDV',
    location_code: '2462',
  },
  {
    name: 'Mali',
    alpha_2: 'ML',
    alpha_3: 'MLI',
    location_code: '2466',
  },
  {
    name: 'Malta',
    alpha_2: 'MT',
    alpha_3: 'MLT',
    location_code: '2470',
  },
  {
    name: 'Marshall Islands',
    alpha_2: 'MH',
    alpha_3: 'MHL',
    location_code: '2584',
  },
  {
    name: 'Martinique',
    alpha_2: 'MQ',
    alpha_3: 'MTQ',
    location_code: '2474',
  },
  {
    name: 'Mauritania',
    alpha_2: 'MR',
    alpha_3: 'MRT',
    location_code: '2478',
  },
  {
    name: 'Mauritius',
    alpha_2: 'MU',
    alpha_3: 'MUS',
    location_code: '2480',
  },
  {
    name: 'Mayotte',
    alpha_2: 'YT',
    alpha_3: 'MYT',
    location_code: '2175',
  },
  {
    name: 'Mexico',
    alpha_2: 'MX',
    alpha_3: 'MEX',
    location_code: '2484',
  },
  {
    name: 'Micronesia (Federated States of)',
    alpha_2: 'FM',
    alpha_3: 'FSM',
    location_code: '2583',
  },
  {
    name: 'Moldova, Republic of',
    alpha_2: 'MD',
    alpha_3: 'MDA',
    location_code: '2498',
  },
  {
    name: 'Monaco',
    alpha_2: 'MC',
    alpha_3: 'MCO',
    location_code: '2492',
  },
  {
    name: 'Mongolia',
    alpha_2: 'MN',
    alpha_3: 'MNG',
    location_code: '2496',
  },
  {
    name: 'Montenegro',
    alpha_2: 'ME',
    alpha_3: 'MNE',
    location_code: '2499',
  },
  {
    name: 'Montserrat',
    alpha_2: 'MS',
    alpha_3: 'MSR',
    location_code: '2500',
  },
  {
    name: 'Morocco',
    alpha_2: 'MA',
    alpha_3: 'MAR',
    location_code: '2504',
  },
  {
    name: 'Mozambique',
    alpha_2: 'MZ',
    alpha_3: 'MOZ',
    location_code: '2508',
  },
  {
    name: 'Myanmar',
    alpha_2: 'MM',
    alpha_3: 'MMR',
    location_code: '2104',
  },
  {
    name: 'Namibia',
    alpha_2: 'NA',
    alpha_3: 'NAM',
    location_code: '2516',
  },
  {
    name: 'Nauru',
    alpha_2: 'NR',
    alpha_3: 'NRU',
    location_code: '2520',
  },
  {
    name: 'Nepal',
    alpha_2: 'NP',
    alpha_3: 'NPL',
    location_code: '2524',
  },
  {
    name: 'Netherlands',
    alpha_2: 'NL',
    alpha_3: 'NLD',
    location_code: '2528',
  },
  {
    name: 'New Caledonia',
    alpha_2: 'NC',
    alpha_3: 'NCL',
    location_code: '2540',
  },
  {
    name: 'New Zealand',
    alpha_2: 'NZ',
    alpha_3: 'NZL',
    location_code: '2554',
  },
  {
    name: 'Nicaragua',
    alpha_2: 'NI',
    alpha_3: 'NIC',
    location_code: '2558',
  },
  {
    name: 'Niger',
    alpha_2: 'NE',
    alpha_3: 'NER',
    location_code: '2562',
  },
  {
    name: 'Nigeria',
    alpha_2: 'NG',
    alpha_3: 'NGA',
    location_code: '2566',
  },
  {
    name: 'Niue',
    alpha_2: 'NU',
    alpha_3: 'NIU',
    location_code: '2570',
  },
  {
    name: 'Norfolk Island',
    alpha_2: 'NF',
    alpha_3: 'NFK',
    location_code: '2574',
  },
  {
    name: 'North Macedonia',
    alpha_2: 'MK',
    alpha_3: 'MKD',
    location_code: '2807',
  },
  {
    name: 'Northern Mariana Islands',
    alpha_2: 'MP',
    alpha_3: 'MNP',
    location_code: '2580',
  },
  {
    name: 'Norway',
    alpha_2: 'NO',
    alpha_3: 'NOR',
    location_code: '2578',
  },
  {
    name: 'Oman',
    alpha_2: 'OM',
    alpha_3: 'OMN',
    location_code: '2512',
  },
  {
    name: 'Pakistan',
    alpha_2: 'PK',
    alpha_3: 'PAK',
    location_code: '2586',
  },
  {
    name: 'Palau',
    alpha_2: 'PW',
    alpha_3: 'PLW',
    location_code: '2585',
  },
  {
    name: 'Palestine, State of',
    alpha_2: 'PS',
    alpha_3: 'PSE',
    location_code: '2275',
  },
  {
    name: 'Panama',
    alpha_2: 'PA',
    alpha_3: 'PAN',
    location_code: '2591',
  },
  {
    name: 'Papua New Guinea',
    alpha_2: 'PG',
    alpha_3: 'PNG',
    location_code: '2598',
  },
  {
    name: 'Paraguay',
    alpha_2: 'PY',
    alpha_3: 'PRY',
    location_code: '2600',
  },
  {
    name: 'Peru',
    alpha_2: 'PE',
    alpha_3: 'PER',
    location_code: '2604',
  },
  {
    name: 'Philippines',
    alpha_2: 'PH',
    alpha_3: 'PHL',
    location_code: '2608',
  },
  {
    name: 'Pitcairn',
    alpha_2: 'PN',
    alpha_3: 'PCN',
    location_code: '2612',
  },
  {
    name: 'Poland',
    alpha_2: 'PL',
    alpha_3: 'POL',
    location_code: '2616',
  },
  {
    name: 'Portugal',
    alpha_2: 'PT',
    alpha_3: 'PRT',
    location_code: '2620',
  },
  {
    name: 'Puerto Rico',
    alpha_2: 'PR',
    alpha_3: 'PRI',
    location_code: '2630',
  },
  {
    name: 'Qatar',
    alpha_2: 'QA',
    alpha_3: 'QAT',
    location_code: '2634',
  },
  {
    name: 'Réunion',
    alpha_2: 'RE',
    alpha_3: 'REU',
    location_code: '2638',
  },
  {
    name: 'Romania',
    alpha_2: 'RO',
    alpha_3: 'ROU',
    location_code: '2642',
  },
  {
    name: 'Russian Federation',
    alpha_2: 'RU',
    alpha_3: 'RUS',
    location_code: '2643',
  },
  {
    name: 'Rwanda',
    alpha_2: 'RW',
    alpha_3: 'RWA',
    location_code: '2646',
  },
  {
    name: 'Saint Barthélemy',
    alpha_2: 'BL',
    alpha_3: 'BLM',
    location_code: '2652',
  },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    alpha_2: 'SH',
    alpha_3: 'SHN',
    location_code: '2654',
  },
  {
    name: 'Saint Kitts and Nevis',
    alpha_2: 'KN',
    alpha_3: 'KNA',
    location_code: '2659',
  },
  {
    name: 'Saint Lucia',
    alpha_2: 'LC',
    alpha_3: 'LCA',
    location_code: '2662',
  },
  {
    name: 'Saint Martin (French part)',
    alpha_2: 'MF',
    alpha_3: 'MAF',
    location_code: '2663',
  },
  {
    name: 'Saint Pierre and Miquelon',
    alpha_2: 'PM',
    alpha_3: 'SPM',
    location_code: '2666',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    alpha_2: 'VC',
    alpha_3: 'VCT',
    location_code: '2670',
  },
  {
    name: 'Samoa',
    alpha_2: 'WS',
    alpha_3: 'WSM',
    location_code: '2882',
  },
  {
    name: 'San Marino',
    alpha_2: 'SM',
    alpha_3: 'SMR',
    location_code: '2674',
  },
  {
    name: 'Sao Tome and Principe',
    alpha_2: 'ST',
    alpha_3: 'STP',
    location_code: '2678',
  },
  {
    name: 'Saudi Arabia',
    alpha_2: 'SA',
    alpha_3: 'SAU',
    location_code: '2682',
  },
  {
    name: 'Senegal',
    alpha_2: 'SN',
    alpha_3: 'SEN',
    location_code: '2686',
  },
  {
    name: 'Serbia',
    alpha_2: 'RS',
    alpha_3: 'SRB',
    location_code: '2688',
  },
  {
    name: 'Seychelles',
    alpha_2: 'SC',
    alpha_3: 'SYC',
    location_code: '2690',
  },
  {
    name: 'Sierra Leone',
    alpha_2: 'SL',
    alpha_3: 'SLE',
    location_code: '2694',
  },
  {
    name: 'Singapore',
    alpha_2: 'SG',
    alpha_3: 'SGP',
    location_code: '2702',
  },
  {
    name: 'Sint Maarten (Dutch part)',
    alpha_2: 'SX',
    alpha_3: 'SXM',
    location_code: '2534',
  },
  {
    name: 'Slovakia',
    alpha_2: 'SK',
    alpha_3: 'SVK',
    location_code: '2703',
  },
  {
    name: 'Slovenia',
    alpha_2: 'SI',
    alpha_3: 'SVN',
    location_code: '2705',
  },
  {
    name: 'Solomon Islands',
    alpha_2: 'SB',
    alpha_3: 'SLB',
    location_code: '2090',
  },
  {
    name: 'Somalia',
    alpha_2: 'SO',
    alpha_3: 'SOM',
    location_code: '2706',
  },
  {
    name: 'South Africa',
    alpha_2: 'ZA',
    alpha_3: 'ZAF',
    location_code: '2710',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    alpha_2: 'GS',
    alpha_3: 'SGS',
    location_code: '2239',
  },
  {
    name: 'South Sudan',
    alpha_2: 'SS',
    alpha_3: 'SSD',
    location_code: '2728',
  },
  {
    name: 'Spain',
    alpha_2: 'ES',
    alpha_3: 'ESP',
    location_code: '2724',
  },
  {
    name: 'Sri Lanka',
    alpha_2: 'LK',
    alpha_3: 'LKA',
    location_code: '2144',
  },
  {
    name: 'Sudan',
    alpha_2: 'SD',
    alpha_3: 'SDN',
    location_code: '2729',
  },
  {
    name: 'Suriname',
    alpha_2: 'SR',
    alpha_3: 'SUR',
    location_code: '2740',
  },
  {
    name: 'Svalbard and Jan Mayen',
    alpha_2: 'SJ',
    alpha_3: 'SJM',
    location_code: '2744',
  },
  {
    name: 'Sweden',
    alpha_2: 'SE',
    alpha_3: 'SWE',
    location_code: '2752',
  },
  {
    name: 'Switzerland',
    alpha_2: 'CH',
    alpha_3: 'CHE',
    location_code: '2756',
  },
  {
    name: 'Syrian Arab Republic',
    alpha_2: 'SY',
    alpha_3: 'SYR',
    location_code: '2760',
  },
  {
    name: 'Taiwan, Province of China',
    alpha_2: 'TW',
    alpha_3: 'TWN',
    location_code: '2158',
  },
  {
    name: 'Tajikistan',
    alpha_2: 'TJ',
    alpha_3: 'TJK',
    location_code: '2762',
  },
  {
    name: 'Tanzania, United Republic of',
    alpha_2: 'TZ',
    alpha_3: 'TZA',
    location_code: '2834',
  },
  {
    name: 'Thailand',
    alpha_2: 'TH',
    alpha_3: 'THA',
    location_code: '2764',
  },
  {
    name: 'Timor-Leste',
    alpha_2: 'TL',
    alpha_3: 'TLS',
    location_code: '2626',
  },
  {
    name: 'Togo',
    alpha_2: 'TG',
    alpha_3: 'TGO',
    location_code: '2768',
  },
  {
    name: 'Tokelau',
    alpha_2: 'TK',
    alpha_3: 'TKL',
    location_code: '2772',
  },
  {
    name: 'Tonga',
    alpha_2: 'TO',
    alpha_3: 'TON',
    location_code: '2776',
  },
  {
    name: 'Trinidad and Tobago',
    alpha_2: 'TT',
    alpha_3: 'TTO',
    location_code: '2780',
  },
  {
    name: 'Tunisia',
    alpha_2: 'TN',
    alpha_3: 'TUN',
    location_code: '2788',
  },
  {
    name: 'Turkey',
    alpha_2: 'TR',
    alpha_3: 'TUR',
    location_code: '2792',
  },
  {
    name: 'Turkmenistan',
    alpha_2: 'TM',
    alpha_3: 'TKM',
    location_code: '2795',
  },
  {
    name: 'Turks and Caicos Islands',
    alpha_2: 'TC',
    alpha_3: 'TCA',
    location_code: '2796',
  },
  {
    name: 'Tuvalu',
    alpha_2: 'TV',
    alpha_3: 'TUV',
    location_code: '2798',
  },
  {
    name: 'Uganda',
    alpha_2: 'UG',
    alpha_3: 'UGA',
    location_code: '2800',
  },
  {
    name: 'Ukraine',
    alpha_2: 'UA',
    alpha_3: 'UKR',
    location_code: '2804',
  },
  {
    name: 'United Arab Emirates',
    alpha_2: 'AE',
    alpha_3: 'ARE',
    location_code: '2784',
  },
  {
    name: 'United Kingdom of Great Britain and Northern Ireland',
    alpha_2: 'GB',
    alpha_3: 'GBR',
    location_code: '2826',
  },
  {
    name: 'United States of America',
    alpha_2: 'US',
    alpha_3: 'USA',
    location_code: '2840',
  },
  {
    name: 'United States Minor Outlying Islands',
    alpha_2: 'UM',
    alpha_3: 'UMI',
    location_code: '2581',
  },
  {
    name: 'Uruguay',
    alpha_2: 'UY',
    alpha_3: 'URY',
    location_code: '2858',
  },
  {
    name: 'Uzbekistan',
    alpha_2: 'UZ',
    alpha_3: 'UZB',
    location_code: '2860',
  },
  {
    name: 'Vanuatu',
    alpha_2: 'VU',
    alpha_3: 'VUT',
    location_code: '2548',
  },
  {
    name: 'Venezuela (Bolivarian Republic of)',
    alpha_2: 'VE',
    alpha_3: 'VEN',
    location_code: '2862',
  },
  {
    name: 'Viet Nam',
    alpha_2: 'VN',
    alpha_3: 'VNM',
    location_code: '2704',
  },
  {
    name: 'Virgin Islands (British)',
    alpha_2: 'VG',
    alpha_3: 'VGB',
    location_code: '2092',
  },
  {
    name: 'Virgin Islands (U.S.)',
    alpha_2: 'VI',
    alpha_3: 'VIR',
    location_code: '2850',
  },
  {
    name: 'Wallis and Futuna',
    alpha_2: 'WF',
    alpha_3: 'WLF',
    location_code: '2876',
  },
  {
    name: 'Western Sahara',
    alpha_2: 'EH',
    alpha_3: 'ESH',
    location_code: '2732',
  },
  {
    name: 'Yemen',
    alpha_2: 'YE',
    alpha_3: 'YEM',
    location_code: '2887',
  },
  {
    name: 'Zambia',
    alpha_2: 'ZM',
    alpha_3: 'ZMB',
    location_code: '2894',
  },
  {
    name: 'Zimbabwe',
    alpha_2: 'ZW',
    alpha_3: 'ZWE',
    location_code: '2716',
  },
];

export const getCountryDetailsByAlpfa2 = (alpha2) =>
  COUNTRIES.find((country) => country?.['alpha_2']?.toUpperCase() === alpha2?.toUpperCase());

export const getCountryDetailsByAlpfa3 = (alpha3) =>
  COUNTRIES.find((country) => country?.['alpha_3']?.toUpperCase() === alpha3?.toUpperCase());

export const LANGUAGES = [
  { language_code: 'aa', name: 'Afar' },
  { language_code: 'ab', name: 'Abkhazian' },
  { language_code: 'ae', name: 'Avestan' },
  { language_code: 'af', name: 'Afrikaans' },
  { language_code: 'ak', name: 'Akan' },
  { language_code: 'am', name: 'Amharic' },
  { language_code: 'an', name: 'Aragonese' },
  { language_code: 'ar', name: 'Arabic' },
  { language_code: 'as', name: 'Assamese' },
  { language_code: 'av', name: 'Avaric' },
  { language_code: 'ay', name: 'Aymara' },
  { language_code: 'az', name: 'Azerbaijani' },
  { language_code: 'ba', name: 'Bashkir' },
  { language_code: 'be', name: 'Belarusian' },
  { language_code: 'bg', name: 'Bulgarian' },
  { language_code: 'bh', name: 'Bihari languages' },
  { language_code: 'bi', name: 'Bislama' },
  { language_code: 'bm', name: 'Bambara' },
  { language_code: 'bn', name: 'Bengali' },
  { language_code: 'bo', name: 'Tibetan' },
  { language_code: 'br', name: 'Breton' },
  { language_code: 'bs', name: 'Bosnian' },
  { language_code: 'ca', name: 'Catalan; Valencian' },
  { language_code: 'ce', name: 'Chechen' },
  { language_code: 'ch', name: 'Chamorro' },
  { language_code: 'co', name: 'Corsican' },
  { language_code: 'cr', name: 'Cree' },
  { language_code: 'cs', name: 'Czech' },
  {
    language_code: 'cu',
    name: 'Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic',
  },
  { language_code: 'cv', name: 'Chuvash' },
  { language_code: 'cy', name: 'Welsh' },
  { language_code: 'da', name: 'Danish' },
  { language_code: 'de', name: 'German' },
  { language_code: 'dv', name: 'Divehi; Dhivehi; Maldivian' },
  { language_code: 'dz', name: 'Dzongkha' },
  { language_code: 'ee', name: 'Ewe' },
  { language_code: 'el', name: 'Greek, Modern (1453-)' },
  { language_code: 'en', name: 'English' },
  { language_code: 'eo', name: 'Esperanto' },
  { language_code: 'es', name: 'Spanish; Castilian' },
  { language_code: 'et', name: 'Estonian' },
  { language_code: 'eu', name: 'Basque' },
  { language_code: 'fa', name: 'Persian' },
  { language_code: 'ff', name: 'Fulah' },
  { language_code: 'fi', name: 'Finnish' },
  { language_code: 'fj', name: 'Fijian' },
  { language_code: 'fo', name: 'Faroese' },
  { language_code: 'fr', name: 'French' },
  { language_code: 'fy', name: 'Western Frisian' },
  { language_code: 'ga', name: 'Irish' },
  { language_code: 'gd', name: 'Gaelic; Scomttish Gaelic' },
  { language_code: 'gl', name: 'Galician' },
  { language_code: 'gn', name: 'Guarani' },
  { language_code: 'gu', name: 'Gujarati' },
  { language_code: 'gv', name: 'Manx' },
  { language_code: 'ha', name: 'Hausa' },
  { language_code: 'he', name: 'Hebrew' },
  { language_code: 'hi', name: 'Hindi' },
  { language_code: 'ho', name: 'Hiri Motu' },
  { language_code: 'hr', name: 'Croatian' },
  { language_code: 'ht', name: 'Haitian; Haitian Creole' },
  { language_code: 'hu', name: 'Hungarian' },
  { language_code: 'hy', name: 'Armenian' },
  { language_code: 'hz', name: 'Herero' },
  {
    language_code: 'ia',
    name: 'Interlingua (International Auxiliary Language Association)',
  },
  { language_code: 'id', name: 'Indonesian' },
  { language_code: 'ie', name: 'Interlingue; Occidental' },
  { language_code: 'ig', name: 'Igbo' },
  { language_code: 'ii', name: 'Sichuan Yi; Nuosu' },
  { language_code: 'ik', name: 'Inupiaq' },
  { language_code: 'io', name: 'Ido' },
  { language_code: 'is', name: 'Icelandic' },
  { language_code: 'it', name: 'Italian' },
  { language_code: 'iu', name: 'Inuktitut' },
  { language_code: 'ja', name: 'Japanese' },
  { language_code: 'jv', name: 'Javanese' },
  { language_code: 'ka', name: 'Georgian' },
  { language_code: 'kg', name: 'Kongo' },
  { language_code: 'ki', name: 'Kikuyu; Gikuyu' },
  { language_code: 'kj', name: 'Kuanyama; Kwanyama' },
  { language_code: 'kk', name: 'Kazakh' },
  { language_code: 'kl', name: 'Kalaallisut; Greenlandic' },
  { language_code: 'km', name: 'Central Khmer' },
  { language_code: 'kn', name: 'Kannada' },
  { language_code: 'ko', name: 'Korean' },
  { language_code: 'kr', name: 'Kanuri' },
  { language_code: 'ks', name: 'Kashmiri' },
  { language_code: 'ku', name: 'Kurdish' },
  { language_code: 'kv', name: 'Komi' },
  { language_code: 'kw', name: 'Cornish' },
  { language_code: 'ky', name: 'Kirghiz; Kyrgyz' },
  { language_code: 'la', name: 'Latin' },
  { language_code: 'lb', name: 'Luxembourgish; Letzeburgesch' },
  { language_code: 'lg', name: 'Ganda' },
  { language_code: 'li', name: 'Limburgan; Limburger; Limburgish' },
  { language_code: 'ln', name: 'Lingala' },
  { language_code: 'lo', name: 'Lao' },
  { language_code: 'lt', name: 'Lithuanian' },
  { language_code: 'lu', name: 'Luba-Katanga' },
  { language_code: 'lv', name: 'Latvian' },
  { language_code: 'mg', name: 'Malagasy' },
  { language_code: 'mh', name: 'Marshallese' },
  { language_code: 'mi', name: 'Maori' },
  { language_code: 'mk', name: 'Macedonian' },
  { language_code: 'ml', name: 'Malayalam' },
  { language_code: 'mn', name: 'Mongolian' },
  { language_code: 'mr', name: 'Marathi' },
  { language_code: 'ms', name: 'Malay' },
  { language_code: 'mt', name: 'Maltese' },
  { language_code: 'my', name: 'Burmese' },
  { language_code: 'na', name: 'Nauru' },
  {
    language_code: 'nb',
    name: 'Bokmål, Norwegian; Norwegian Bokmål',
  },
  { language_code: 'nd', name: 'Ndebele, North; North Ndebele' },
  { language_code: 'ne', name: 'Nepali' },
  { language_code: 'ng', name: 'Ndonga' },
  { language_code: 'nl', name: 'Dutch; Flemish' },
  { language_code: 'nn', name: 'Norwegian Nynorsk; Nynorsk, Norwegian' },
  { language_code: 'no', name: 'Norwegian' },
  { language_code: 'nr', name: 'Ndebele, South; South Ndebele' },
  { language_code: 'nv', name: 'Navajo; Navaho' },
  { language_code: 'ny', name: 'Chichewa; Chewa; Nyanja' },
  { language_code: 'oc', name: 'Occitan (post 1500)' },
  { language_code: 'oj', name: 'Ojibwa' },
  { language_code: 'om', name: 'Oromo' },
  { language_code: 'or', name: 'Oriya' },
  { language_code: 'os', name: 'Ossetian; Ossetic' },
  { language_code: 'pa', name: 'Punjabi; Panjabi' },
  { language_code: 'pi', name: 'Pali' },
  { language_code: 'pl', name: 'Polish' },
  { language_code: 'ps', name: 'Pushto; Pashto' },
  { language_code: 'pt', name: 'Portuguese' },
  { language_code: 'qu', name: 'Quechua' },
  { language_code: 'rm', name: 'Romansh' },
  { language_code: 'rn', name: 'Rundi' },
  { language_code: 'ro', name: 'Romanian; Moldavian; Moldovan' },
  { language_code: 'ru', name: 'Russian' },
  { language_code: 'rw', name: 'Kinyarwanda' },
  { language_code: 'sa', name: 'Sanskrit' },
  { language_code: 'sc', name: 'Sardinian' },
  { language_code: 'sd', name: 'Sindhi' },
  { language_code: 'se', name: 'Northern Sami' },
  { language_code: 'sg', name: 'Sango' },
  { language_code: 'si', name: 'Sinhala; Sinhalese' },
  { language_code: 'sk', name: 'Slovak' },
  { language_code: 'sl', name: 'Slovenian' },
  { language_code: 'sm', name: 'Samoan' },
  { language_code: 'sn', name: 'Shona' },
  { language_code: 'so', name: 'Somali' },
  { language_code: 'sq', name: 'Albanian' },
  { language_code: 'sr', name: 'Serbian' },
  { language_code: 'ss', name: 'Swati' },
  { language_code: 'st', name: 'Sotho, Southern' },
  { language_code: 'su', name: 'Sundanese' },
  { language_code: 'sv', name: 'Swedish' },
  { language_code: 'sw', name: 'Swahili' },
  { language_code: 'ta', name: 'Tamil' },
  { language_code: 'te', name: 'Telugu' },
  { language_code: 'tg', name: 'Tajik' },
  { language_code: 'th', name: 'Thai' },
  { language_code: 'ti', name: 'Tigrinya' },
  { language_code: 'tk', name: 'Turkmen' },
  { language_code: 'tl', name: 'Tagalog' },
  { language_code: 'tn', name: 'Tswana' },
  { language_code: 'to', name: 'Tonga (Tonga Islands)' },
  { language_code: 'tr', name: 'Turkish' },
  { language_code: 'ts', name: 'Tsonga' },
  { language_code: 'tt', name: 'Tatar' },
  { language_code: 'tw', name: 'Twi' },
  { language_code: 'ty', name: 'Tahitian' },
  { language_code: 'ug', name: 'Uighur; Uyghur' },
  { language_code: 'uk', name: 'Ukrainian' },
  { language_code: 'ur', name: 'Urdu' },
  { language_code: 'uz', name: 'Uzbek' },
  { language_code: 've', name: 'Venda' },
  { language_code: 'vi', name: 'Vietnamese' },
  { language_code: 'vo', name: 'Volapük' },
  { language_code: 'wa', name: 'Walloon' },
  { language_code: 'wo', name: 'Wolof' },
  { language_code: 'xh', name: 'Xhosa' },
  { language_code: 'yi', name: 'Yiddish' },
  { language_code: 'yo', name: 'Yoruba' },
  { language_code: 'za', name: 'Zhuang; Chuang' },
  { language_code: 'zh', name: 'Chinese' },
  { language_code: 'zu', name: 'Zulu' },
];

export const getCountryDetailsByName = (country) => {
  const count = COUNTRIES.find((countryDetails) => countryDetails?.name?.toUpperCase() === country?.toUpperCase());
  if (!count) {
    const updatedCount = COUNTRIES.find((countryDetails) =>
      countryDetails?.name?.toUpperCase()?.includes(country?.toUpperCase())
    );
    return {
      ...updatedCount,
      name: country,
    };
  }
  return count;
};
export const getlLanguageByLanguage_code = (language_code) =>
  LANGUAGES.find((language) => language?.language_code?.toUpperCase() === language_code?.toUpperCase());

export const getLanguageDetailsByLanguage = (language) => {
  const lang = LANGUAGES.find((languageDetails) => languageDetails?.name?.toUpperCase() === language?.toUpperCase());
  if (!lang) {
    //// IF current langauge have alfa 2 value not full name, eg if Lnaguage = 'en' then find langauge details by language code
    const getByCodeObj = getlLanguageByLanguage_code(language) || null;

    //// this beacuse of, some time langaues are like "Spanish; Castilian",
    //// "Greek, Modern (1453-)", thats why second options to find the language coed is..
    const getByNameObj =
      LANGUAGES.find((languageDetails) => languageDetails?.name?.toUpperCase()?.includes(language?.toUpperCase())) ||
      null;

    const updatedLang = getByCodeObj ? getByCodeObj : getByNameObj;
    return {
      ...updatedLang,
      // name: language,
    };
  }
  return lang;
};
